import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatDriverTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatEndorsements',
})
export class FormatEndorsementsPipe implements PipeTransform {
  /**
   * Takes a job and displays the required endorsements in HTML list item format
   */
  transform(job: any, ...args) {
    let html = '';

    let endorsements = {
      hEndorsement: 'H - Hazardous Material',
      nEndorsement: 'N - Tanker Vehicles',
      pEndorsement: 'P - Passengers',
      sEndorsement: 'S - School Bus',
      tEndorsement: 'T - Doubles or Triples',
      xEndorsement: 'X - Combo for Hazmat and Tank',
      twicCard: 'TWIC Card',
    };

    // no requirements are specified
    if (!_.includes(job.endorsements, true)) {
      html = '<li>No Requirement Specified</li>';
      return html;
    }

    _.forEach(job.endorsements, (value, key) => {
      if (value) {
        html += '<li>' + endorsements[key] + '</li>';
      }
    });

    return html || 'No Requirement Specified';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-endorsements/format-endorsements.ts